import React, { lazy, Suspense } from "react";
import { useRoutes } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import BackupDownloadComponent from "../Component/Download";
//import Inventory from "../Component/Admin/Inventory/Inventory";
import AdminPage from "../Component/Admin/Store/AdminPage";
//import StockManagementPage from "../Component/Admin/Store/AdminPage";
import StockManagementPage from "../Component/Admin/Store/StockManagement";
import Purchase from "../Component/Admin/Store/Purchase/Purchase";
import Suppliers from "../Component/Admin/Store/Suppliers";
import Consumption from "../Component/Admin/Store/Consumption";
import PurchaseReturns from "../Component/Admin/Store/Purchase/PurchaseReturns";
import PaupetSoftErpLaunching from "../Component/Home/ERPHome";
import Dashboard from "../Component/Dashboard/Dashboard";
import Rooms from "../Component/Hotel/rooms/Rooms";
import BillingHome from "../Component/Hotel/billing/BillingHome";
import GuestsMaster from "../Component/Hotel/guests/GuestsMaster";
import TransactionForm from "../Component/Hotel/billing/TransactionForm";
import TransactionSummary from "../Component/Hotel/billing/TransactionSummary";
import RoomLayoutView from "../Component/Hotel/rooms/RoomLayoutView";
import ReservationDetails from "../Component/Hotel/Reservation/ReservationDetails";
import LettersComponent from "../Component/Admin/Letters/LettersComponent";
import UtilityManagement from "../Component/Admin/UtilityManagement";
import QRCodeGenerator from "../Component/Admin/QRCode/QrCodeGenerator";
const CreateBooking = lazy(
  () => import("../Component/Hotel/Reservation/CreateBooking"),
);
//const AdminPage = lazy(() => import("../Component/Production/AdminPage"));
const ReservationHome = lazy(
  () => import("../Component/Hotel/Reservation/ReservationHome"),
);
const CompletedJobs = lazy(
  () => import("../Component/Production/CompletedJobs"),
);
const WorkOrder = lazy(() => import("../Component/Production/WorkOrder"));
const WorkInProgress = lazy(
  () => import("../Component/Production/WorkInProgress"),
);
const ProductionPlanning = lazy(
  () => import("../Component/Production/ProductionPlanning"),
);
const JobOrder = lazy(() => import("../Component/Production/JobOrder"));
const CallLogEntry = lazy(() => import("../Component/Enquiry/CallLogEntry"));
const AdminIDCard = lazy(() => import("../Component/Admin/IDCard/AdminIDCard"));
const IDCard = lazy(() => import("../Component/Admin/IDCard/IDCard"));
const SupportPanel = lazy(() => import("../Component/Support/SupportPanel"));
 
const HostelForm = lazy(() => import("../Component/HR/HeadCount"));
// Lazy-loaded components
//import Login from "../Components/View/Authentication/Login";
//import CRM from "../Components/View/CRM/CRM";

const Unauthorized = lazy(() => import("./Unauthorized"));
const Home = lazy(() => import("../Component/Home/Home"));
const PaySlipList = lazy(() => import("../Component/Accounts/PaySlipList"));

 
 
const EmployeeList = lazy(() => import("../Component/Employees/EmployeeList"));
const InvoiceList = lazy(() => import("../Component/Accounts/InvoiceList"));
const Login = lazy(() => import("../Component/Auth/Login"));
const OfficeAutomationDashboard = lazy(
  () => import("../Component/Home/OfficeAutomationDashboard"),
);

const EmployeeManagement = lazy(
  () => import("../Component/Employees/EmployeeManagement"),
);
const LeaveManagement = lazy(
  () => import("../Component/Employees/LeaveManagent"),
);
const PayrollProcessing = lazy(
  () => import("../Component/Accounts/PayrollProcessing"),
);
const PaySlip = lazy(() => import("../Component/Accounts/PaySlip"));
const AttendanceForm = lazy(
  () => import("../Component/Employees/Attendance/AttendanceForm"),
);
const ChairmanDashboard = lazy(
  () => import("../Component/Dashboard/ChairmanDashboard"),
);
const EnquiryForm = lazy(() => import("../Component/Enquiry/EnquiryForm"));

const FeeReceipt = lazy(() => import("../Component/Accounts/FeeReceipt"));
 
const EventScheduler = lazy(
  () => import("../Component/Academic/EventScheduler"),
);
const HostelManagement = lazy(
  () => import("../Component/Admin/HostelManagement"),
);
const AccountsManagement = lazy(
  () => import("../Component/Accounts/AccountsManagement"),
);

const AdminDashboard = lazy(
  () => import("../Component/Dashboard/AdminDashboard"),
);
const AccountsDashboard = lazy(
  () => import("../Component/Dashboard/AccountsDashboard"),
);
 
const GenerateInvoice = lazy(
  () => import("../Component/Accounts/GenerateInvoice"),
);
const PaymentHistory = lazy(
  () => import("../Component/Accounts/PaymentHistory"),
);
const PaymentOptions = lazy(
  () => import("../Component/Accounts/PaymentOptions"),
);
const ManagePurchase = lazy(
  () => import("../Component/Accounts/Purchase/ManagePurchase"),
);

const ExpenseEntry = lazy(
  () => import("../Component/Accounts/Expenses/ExpenseEntry"),
);
const Ledger = lazy(() => import("../Component/Accounts/Ledger"));
const HotelDashboard = lazy(
  () => import("../Component/Dashboard/HotelDashboard"),
);
const ReservationList = lazy(
  () => import("../Component/Hotel/Reservation/ReservationList"),
);
const AttendanceCamera = lazy(
  () => import("../Component/Attendance/AttendanceCamera"),
);

export default function Routing({ userRights, setUserRights }) {
  let elements = useRoutes([
    {
      path: "/",
      //   element: <Login setUserRights={setUserRights} />,
      element: <PaupetSoftErpLaunching setUserRights={setUserRights} />,
    },
    {
      path: "unauthorized",
      element: <Unauthorized />,
    },
    {
      path: "home",
      element: (
        <ProtectedRoute
          element={<Home />}
    //  element={<RoomLayoutView />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "Teaching",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "rooms_home",
      element: (
        <ProtectedRoute
      //    element={<Home />}
      element={<RoomLayoutView />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "Teaching",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "chairman",
      element: (
        <ProtectedRoute
          element={<ChairmanDashboard />}
          rights={userRights}
          allowedRights={["Chairman", "SuperAdmin"]}
        />
      ),
    },
    {
      ///production/job-create"
      path: "production",
      element: (
        <ProtectedRoute
          element={<StockManagementPage />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
      children: [
        { path: "", element: <StockManagementPage /> },
        { path: "job-create", element: <JobOrder /> },
        { path: "Job-list", element: <JobOrder /> },
        { path: "Planning", element: <ProductionPlanning /> },
        { path: "work-order", element: <WorkOrder /> },
        { path: "wip", element: <WorkInProgress /> },
        { path: "completed", element: <CompletedJobs /> },
      ],
      //OfficeAutomationDashboard
    },
    {
      path: "enquiry_form",
      element: (
        <ProtectedRoute
          element={<EnquiryForm />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
    },

    // children: [{ path: "", element: <CandidateRecruitmentForm /> }], store

    {
      path: "eventscheduler",
      element: (
        <ProtectedRoute
          element={<EventScheduler />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "Teaching",
            "SuperAdmin",
          ]}
        />
      ),
    },
     {
      path: "qr-code-generator",
      element: (
        <ProtectedRoute
          element={<QRCodeGenerator />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Chairman", "Accounts"]}
        />
      ),
    },
     {
      path: "eventscheduler",
      element: (
        <ProtectedRoute
          element={<EventScheduler />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "Teaching",
            "SuperAdmin",
          ]}
        />
      ),
    },
 
    {
      path: "employee-list",
      element: (
        <ProtectedRoute
          element={<EmployeeList />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Principal",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "hostel_management",
      element: (
        <ProtectedRoute
          element={<HostelManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Warden",
          ]}
        />
      ),
    },
    {
      path: "accounts_management",
      element: (
        <ProtectedRoute
          element={<AccountsManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "invoice_list",
      element: (
        <ProtectedRoute
          element={<InvoiceList />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "AdminExecutive",
            "SuperAdmin",
          ]}
        />
      ),
    },

    {
      path: "purchase_management",
      element: (
        <ProtectedRoute
          element={<ManagePurchase />}
          rights={userRights}
          allowedRights={["Admin", "Chairman", "Accounts", "SuperAdmin","AdminExecutive"]}
        />
      ),
    },
    
    {
      path: "generate-bills",
      element: (
        <ProtectedRoute
          element={<GenerateInvoice />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "AdminExecutive",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "generate-bills/view/:id",
      element: (
        <ProtectedRoute
          element={<GenerateInvoice />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "AdminExecutive",
            "SuperAdmin",
          ]}
        />
      ),
    },
     
    
    {
      path: "collect-payments",
      element: (
        <ProtectedRoute
          element={<PaymentOptions />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "payment-history",
      element: (
        <ProtectedRoute
          element={<PaymentHistory />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Accounts",
            "AdminExecutive",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "admin_dashboard",
      element: (
        <ProtectedRoute
          element={<AdminDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin"
          ]}
        />
      ),
    },
    //inventory_form

    {
      ///production/job-create"
      path: "store-admin",
      element: (
        <ProtectedRoute
          element={<AdminPage />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
      children: [
        { path: "", element: <StockManagementPage /> },
        { path: "sku", element: <StockManagementPage /> },
        { path: "purchase", element: <Purchase /> },
        { path: "suppliers", element: <Suppliers /> },
        { path: "consume", element: <Consumption /> },
        { path: "rtn-purchase", element: <PurchaseReturns /> },
      ],
      //OfficeAutomationDashboard
    },
     {
      path: "UtilityManagement",
      element: (
        <ProtectedRoute
          element={<UtilityManagement />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Chairman", "Accounts","AdminExecutive"]}
        />
      ),
    },
    {
      ///production/job-create"
      path: "reservations",
      element: (
        <ProtectedRoute
          element={<ReservationHome />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
      children: [
        { path: "", element: <CreateBooking /> },
        { path: "create", element: <CreateBooking /> },
        { path: "list", element: <ReservationList /> },
        { path: "details", element: <ReservationDetails /> },
      ],
      //OfficeAutomationDashboard
    },
    {
      ///production/job-create"
      path: "rooms",
      element: (
        <ProtectedRoute
          element={<Rooms />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
      children: [
        { path: "master", element: <Rooms /> },
        { path: "create", element: <CreateBooking /> },
        { path: "list", element: <ReservationList /> },
      ],
      //OfficeAutomationDashboard
    },
    {
      ///production/job-create"
      path: "guests",
      element: (
        <ProtectedRoute
          element={<GuestsMaster />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "AdminExecutive",
            "Accounts",
          ]}
        />
      ),
      children: [
        { path: "master", element: <GuestsMaster /> },
        { path: "create", element: <CreateBooking /> },
        { path: "list", element: <ReservationList /> },
      ],
      //OfficeAutomationDashboard
    },
    {
      ///production/job-create"
      path: "finance",
      element: (
        <ProtectedRoute
          element={<BillingHome />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Chairman",
            "HR Executive",
            "Recruiter",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
      children: [
        { path: "billing", element: <BillingHome /> },
        { path: "create", element: <CreateBooking /> },
        { path: "list", element: <ReservationList /> },
      ],
      //OfficeAutomationDashboard
    },
      
  /* ================= TRANSACTION PAYMENT ================= */
  {
    path: "transactions/payment", // ✅ Direct independent path
    element: (
      <ProtectedRoute
        element={<TransactionForm />}
        rights={userRights}
        allowedRights={["Admin", "Chairman", "Accounts", "HR Executive", "Recruiter", "AdminExecutive", "SuperAdmin"]}
      />
    ),
  },

  /* ================= TRANSACTION SUMMARY ================= */
  {
    path: "transactions/summary", // ✅ Direct independent path
    element: (
      <ProtectedRoute
        element={<TransactionSummary />}
        rights={userRights}
        allowedRights={["Admin", "Chairman", "Accounts", "HR Executive", "Recruiter", "AdminExecutive", "SuperAdmin"]}
      />
    ),
  },
    {
      path: "id-card",
      element: (
        <ProtectedRoute
          element={<IDCard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Principal",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "admin-id-card",
      element: (
        <ProtectedRoute
          element={<AdminIDCard />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "accounts_dashboard",
      element: (
        <ProtectedRoute
          element={<AccountsDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Accounts",
              "SuperAdmin",
          ]}
        />
      ),
    },
    {
      path: "dashboard",
      element: (
        <ProtectedRoute
          //  element={<OfficeAutomationDashboard />}
          element={<Dashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "hotel-dashboard",
      element: (
        <ProtectedRoute
          //  element={<OfficeAutomationDashboard />}
          element={<HotelDashboard />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "emp-management",
      element: (
        <ProtectedRoute
          element={<EmployeeManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "Accounts",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "attendance",//attendance-camera
      element: (
        <ProtectedRoute
          element={<AttendanceForm />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "SuperAdmin"
          ]}
        />
      ),
    },
  {
      path: "attendance-camera",
      element: (
        <ProtectedRoute
          element={<AttendanceCamera />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "AdminExecutive",
            "SuperAdmin"
          ]}
        />
      ),
    },
     
    {
      path: "leave-management",
      element: (
        <ProtectedRoute
          element={<LeaveManagement />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "payroll",
      element: (
        <ProtectedRoute
          element={<PayrollProcessing />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Accounts",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "payslip",
      element: (
        <ProtectedRoute
          element={<PaySlip />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "HR Executive",
            "Recruiter",
            "Chairman",
            "Accounts",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "paysliplist",
      element: (
        <ProtectedRoute
          element={<PaySlipList />}
          rights={userRights}
          allowedRights={["Admin", "HR", "Chairman", "Accounts", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "letter",
      element: (
        <ProtectedRoute
          element={<LettersComponent />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "Chairman",
            "Recruiter",
            "AdminExecutive",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "certificate",
      element: (
        <ProtectedRoute
          element={<LettersComponent />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "HR",
            "Chairman",
            "Recruiter",
            "AdminExecutive",
            "SuperAdmin"
          ]}
        />
      ),
    },

    {
      path: "download_backup",
      element: (
        <ProtectedRoute
          element={<BackupDownloadComponent />}
          rights={userRights}
          allowedRights={[ "SuperAdmin"]}
        />
      ),
    },
    {
      path: "expense-entry",
      element: (
        <ProtectedRoute
          element={<ExpenseEntry />}
          rights={userRights}
          allowedRights={["Admin", "SuperAdmin", "Accounts", "Chairman", "AdminExecutive"]}
        />
      ),
    },
   
 
    {
      path: "headcount",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <HostelForm />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "Warden",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "ledger",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <Ledger />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Chairman", "AdminExecutive", "SuperAdmin"]}
        />
      ),
    },
    {
      path: "callcenter",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <CallLogEntry />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "Warden",
            "SuperAdmin"
          ]}
        />
      ),
    },
    {
      path: "support",
      element: <SupportPanel />,
    },
  ]);

  return <Suspense fallback={<div>Loading...</div>}>{elements}</Suspense>;
}
